export default __webpack_public_path__ + "static/homeImg-0bed318c01af0a0b37e6ac099f2a887f.webp";